// src/components/notification-item/context.tsx
import { createContext, useContext } from "react";
var NotificationItemContext = createContext(void 0);
var NotificationItemProvider = NotificationItemContext.Provider;
var useNotificationItem = (part) => {
  const context = useContext(NotificationItemContext);
  if (!context) {
    throw new Error(`<NotificationItem.${part} /> must be rendered inside <NotificationItem />`);
  }
  return context;
};
var NotificationHandlersContext = createContext({});
var NotificationHandlersProvider = NotificationHandlersContext.Provider;
var useInheritedNotificationHandlers = () => useContext(NotificationHandlersContext);
export {
  NotificationHandlersProvider,
  NotificationItemProvider,
  useInheritedNotificationHandlers,
  useNotificationItem
};
//# sourceMappingURL=context.js.map